import React from 'react';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { LD_PROJECT_TRASH_CAN_FLAG } from 'constants/featureFlags';
import { translate } from 'translations/i18n';

import ConfirmationModal from 'components/core/ConfirmationModal';

const DeletePhotosModal = ({ photoCount, onRequestClose, onDelete }) => {
  const flags = useFlags();
  const isTrashCanEnabled = flags[LD_PROJECT_TRASH_CAN_FLAG];
  return (
    <ConfirmationModal
      confirmAction={onDelete}
      confirmLabel={
        isTrashCanEnabled
          ? translate('photos.deletePhotosModal.confirmMoveToTrash')
          : translate('common.confirmDelete')
      }
      cancelLabel={
        isTrashCanEnabled
          ? translate('common.cancel')
          : translate('common.canclelDelete')
      }
      message={
        isTrashCanEnabled ? (
          <>
            <strong>
              {translate('photos.deletePhotosModal.confirmationMessageTrash')}
            </strong>
            &nbsp;
            {translate(
              'photos.deletePhotosModal.confirmationMessageTrashSecondary',
            )}
          </>
        ) : (
          translate('photos.deletePhotosModal.confirmationMessage', {
            count: photoCount,
          })
        )
      }
      title={
        isTrashCanEnabled
          ? translate('photos.deletePhotosModal.modalTitle', {
              count: photoCount,
            })
          : translate('photos.deletePhotosModal.deletePhotos')
      }
      onRequestClose={onRequestClose}
    />
  );
};

DeletePhotosModal.propTypes = {
  photoCount: PropTypes.number,
  onDelete: PropTypes.func,
  onRequestClose: PropTypes.func,
};

export default DeletePhotosModal;
